import { createContext, useContext } from 'react';

/**
 * Sentinel telling the auth layout to suppress the hero photo and show the
 * neutral backdrop instead — used while a page is still resolving which hero to
 * display (e.g. the guest join page before its `eventType` loads), so the wrong
 * photo never flashes before the right one.
 */
export const HERO_PENDING = Symbol('auth-hero-pending');

/** image src → show that image · HERO_PENDING → neutral backdrop · null → route/default hero */
export type AuthHeroOverride = string | typeof HERO_PENDING | null;

export interface AuthHeroContextValue {
  /** Override the auth layout's left-side hero for the current page. */
  setHeroImage: (override: AuthHeroOverride) => void;
}

const AuthHeroContext = createContext<AuthHeroContextValue>({ setHeroImage: () => {} });

/** Read the auth hero controls from within DefaultAuthLayout's subtree. */
export const useAuthHero = (): AuthHeroContextValue => useContext(AuthHeroContext);

export default AuthHeroContext;
